import React, { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
function PatientDetailHead({ patientId, allData }) {
  const [currentStatus, setCurrentStatus] = useState(null);
  const [paymentType, setPaymentType] = useState(null);

  const [changePatStatus, setChangePatStatus] = useState(false);
  const [sucPrams, setSucPrams] = useState('');

  useEffect(() => {
    setPaymentType(allData?.paymentType);
    setCurrentStatus(allData?.patStatus);
  }, [allData]);

  const handlePaymentSuccess = async (e) => {
    try {
      setPaymentType(e.target.value);
      const response = await post(
        'api/appointment/Appointment/updatePatientPaymentStatus',
        {
          patientId: patientId,
          paymentStatusId: e.target.value,
          appId: allData?.lastestVisit?.appointment_id,
          visitId: allData?.lastestVisit?.id,
        }
      );

      if (response?.status === 200) {
        if (response?.data?.status === 'success') {
          setUiMessage('suc', 'Payment status change successfully.');
        } else if (response?.data?.status === 'billGenerate') {
          setUiMessage(
            'inf',
            'Bill already generated so status cannot be changed.'
          );
        } else {
          setUiMessage('war', 'Failed!');
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleChangePatStatus = (e) => {
    setChangePatStatus(true);
    setSucPrams(e.target.value);
  };

  const handleChangePatStatusConfirm = async () => {
    try {
      setCurrentStatus(sucPrams);
      const response = await post('api/patient/Patient/updatePatientStatus', {
        patientId: patientId,
        patientStatus: sucPrams,
      });

      if (response?.status === 200) {
        setUiMessage('suc', 'Patient status change successfully.');
        setChangePatStatus(false);
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };
  return (
    <div className="chart-right-col-hdr">
      <span className="ch-pt-name">
        <span className="pt-name fontsize13vw bold">{allData?.patName}</span>
        <span className="pt-name">
          <b> DOB:</b> {allData?.dob}, {allData?.age}, {allData?.gender}
        </span>
        <span className="pt-name">
          <b>ID:</b> {allData?.chart_number}
        </span>
        <span className="pt-name">
          <b>PCP:</b> {allData?.pcpFullName}
        </span>
        <span className="pt-name">
          <b>Ref. Physician:</b> {allData?.refProviderFullName}
        </span>
      </span>
      <span className="ch-pt-name">
        <span className="pt-name">
          <b>Next Appt.:</b> {allData?.nextVisitDate}
        </span>
        <span className="pt-name">
          <b>Next Appt. provider: </b>
          {allData?.nextVisitRes}
        </span>
        <span className="pt-name">
          <b>Prev visit.:</b> {allData?.lastVisitDate}
        </span>
        <span className="pt-name">
          <b>Prev visit provider: </b>
          {allData?.lastAppResource}
        </span>
      </span>
      <span className="ch-pt-name">
        <span className="pt-name">
          <b>Payor:</b> {allData?.payorName} {allData?.payorStatus}
        </span>
        <span className="pt-name">
          <b>Payor ID:</b> {allData?.payorId}{' '}
        </span>
        <span className="pt-name">
          <b>PCP Co-pay:</b> {allData?.pcpCoPay}
        </span>
        <span className="pt-name">
          <b> Spec. Co-pay: </b>
          {allData?.speCoPay}
        </span>
      </span>
      <span className="ch-pt-name">
        <span className="pt-name" style={{ display: 'flex' }}>
          <span className="1bold" style={{ width: '100px' }}>
            <b>Payment Type:</b>
          </span>
          <select
            className="appt-col-slct"
            style={{
              width: '50%',
              height: '22px',
              border: '1px solid #dadada',
            }}
            value={paymentType || ''}
            onChange={handlePaymentSuccess}
          >
            {allData?.paymentTypeList &&
              allData?.paymentTypeList.length &&
              allData?.paymentTypeList.map((data) => (
                <option key={data.id} title="" value={data.id}>
                  {data.title}
                </option>
              ))}
          </select>
        </span>
        <span className="pt-name" style={{ display: 'flex' }}>
          <span className="1bold" style={{ width: '100px' }}>
            <b>Quick Links:</b>
          </span>
          <select
            className="appt-col-slct"
            style={{
              width: '50%',
              height: '22px',
              border: '1px solid #dadada',
            }}
          >
            <option value=""></option>
            <option title="" value="8">
              Send Text
            </option>
            <option title="" value="1">
              Upload Document
            </option>
            <option title="" value="2">
              Upload Result
            </option>
            <option title="" value="3">
              Upload Report (CCR/CCD)
            </option>
            <option title="" value="4">
              Generate clinical summary
            </option>
            <option title="" value="5">
              Send Mail
            </option>
            <option title="" value="6">
              Medication Reconciliation
            </option>
            <option title="" value="7">
              Record Message&nbsp;or Request
            </option>

            <option title="" value="9">
              Print Label
            </option>
            <option title="" value="10">
              Print Notes
            </option>
          </select>
        </span>
        <span className="pt-name" style={{ display: 'flex' }}>
          <span className="1bold" style={{ width: '100px' }}>
            <b>Pt. Status:</b>
          </span>
          <select
            value={currentStatus || ''}
            onChange={handleChangePatStatus}
            className="appt-col-slct"
            style={{
              width: '50%',
              height: '22px',
              border: '1px solid #dadada',
            }}
          >
            <option value="1">Active</option>
            <option value="2">Inactive</option>
            <option value="3">Deceased</option>x
          </select>
        </span>
        <span className="pt-name">
          <b>Balance:</b> <span className="red">{allData?.patBal}</span>
        </span>
      </span>
      {changePatStatus && (
        <ConfirmDialog
          title="Patient Status"
          bodytext={"Do you want to change the patient's status?"}
          closeDialog={() => setChangePatStatus(false)}
          successDialog={handleChangePatStatusConfirm}
          sucPrams={sucPrams}
        />
      )}
    </div>
  );
}

export default PatientDetailHead;
